<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="delete-user-confirm-dialog"
  [header]="'dialogs.deleteAccountTitle' | translate"
>
  <div class="delete-user-dialog__body">
    <p class="delete-user-dialog__intro">
      {{ 'dialogs.deleteAccountQuestion' | translate }}
      <strong class="delete-user-dialog__name">"{{ userName }}"</strong>?
    </p>

    <p class="delete-user-dialog__section-title">
      {{ 'dialogs.accountAuto' | translate }}
    </p>
    <ul class="delete-user-dialog__list">
      <li>{{ 'dialogs.liCancelIncomingUser' | translate }}</li>
      <li>{{ 'dialogs.liRemoveAccess' | translate }}</li>
    </ul>

    <div class="delete-user-dialog__credit" data-test="credit-on-deletion">
      <p class="delete-user-dialog__section-title">{{ 'dialogs.creditOnDeletionTitle' | translate }}</p>
      @if (!credit) {
      <p class="delete-user-dialog__credit-note" data-test="credit-unknown">
        {{ 'dialogs.creditOnDeletionUnknown' | translate }}
      </p>
      } @else if (!hasCredit) {
      <p class="delete-user-dialog__credit-note" data-test="credit-none">
        {{ 'dialogs.creditOnDeletionNone' | translate }}
      </p>
      } @else {
      <dl class="delete-user-dialog__credit-amounts">
        <div>
          <dt>{{ 'dialogs.creditOnDeletionToCard' | translate }}</dt>
          <dd data-test="credit-to-card">{{ amount(credit.toCard) }}</dd>
        </div>
        <div>
          <dt>{{ 'dialogs.creditOnDeletionForfeited' | translate }}</dt>
          <dd data-test="credit-forfeited">{{ amount(credit.forfeited) }}</dd>
        </div>
      </dl>
      }
    </div>

    <p class="delete-user-dialog__note">
      {{ 'dialogs.accountMovedTo' | translate }}
      <strong class="delete-user-dialog__emphasis">{{ 'dialogs.deletedItems' | translate }}</strong>
    </p>

    <p class="delete-user-dialog__warning">{{ 'dialogs.cannotBeUndone' | translate }}</p>

    <label class="delete-user-dialog__checkbox">
      <input type="checkbox" [ngModel]="confirmed" (ngModelChange)="onConfirmedChange($event)" />
      {{ 'dialogs.understand' | translate }}
    </label>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="delete-user-dialog__cancel" (click)="onCancel()">
      {{ 'dialogs.cancel' | translate }}
    </button>
    <button
      type="button"
      class="delete-user-dialog__confirm"
      [class.is-active]="confirmed"
      [disabled]="!confirmed || deleting"
      (click)="onConfirm()"
    >
      <i class="pi pi-trash"></i> {{ 'dialogs.deleteAccountBtn' | translate }}
    </button>
  </ng-template>
</p-dialog>
